import { render, staticRenderFns } from "./Worker.vue?vue&type=template&id=2a6e218a&scoped=true&"
import script from "./Worker.vue?vue&type=script&lang=js&"
export * from "./Worker.vue?vue&type=script&lang=js&"
import style0 from "./Worker.vue?vue&type=style&index=0&id=2a6e218a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6e218a",
  null
  
)

export default component.exports